module.exports = __webpack_public_path__ + "static/media/roboto_medium.2267169e.woff";